var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zoom"},[_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.handleRate(10, 'down')}}},[_vm._v("-")]),_c('div',{staticClass:"rate"},[_vm._v(_vm._s(_vm.rate)+"%")]),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.handleRate(10, 'up')}}},[_vm._v("+")])])
}
var staticRenderFns = []

export { render, staticRenderFns }